module.exports = __webpack_public_path__ + "assets/img/654200.e5c9d6df.png";